import Env from "xlcommon/src/environ";
import { authenticatedFetch } from "../../auth/fetch";

const BASE_URL = Env.BASE_URL;
const PROJECTS_URL = `${BASE_URL}/api/cloud/projects`;
const API_VERSION_HEADER = { "Api-Version": "2023.11.28" };

export async function authenticatedRequest<T>({
  path,
  method = "GET",
  body,
}: {
  path: string;
  method?: string; // GET, POST, PUT, PATCH, DELETE
  body?: BodyInit; // Must convert to FormData, JSON.stringify(), etc.
}): Promise<T> {
  const options = {
    method,
    headers: {
      "Content-type": "application/json",
      ...API_VERSION_HEADER,
    },
  };
  if (body) {
    options["body"] = body;
  }
  const response = await authenticatedFetch(`${PROJECTS_URL}${path}`, options);
  if (!response.ok) {
    throw new Error(`Failed to fetch data from ${path}`);
  }
  return await response.json();
}
